// TODO: upgrade to RHF
/**
 * Правила для проверки полей формы при манипуляциях с паролем.
 */
export const FIELD_VALIDATION_RULES = {
  COMPARE_LENGTHS: "compareLengths",
  COMPARE_VALUES: "compareValues",
  COMPARE_MIN_LENGTH: "min",
  EMPTY_LENGTH: "empty",
  COMPARE_RANGE_SUM: "compareRangeSum",
  FORMAT_EMAIL: "formatEmail",
  PHONE_NUMBER_NOT_FULLY: "phoneNumberNotFully",
};
